// Shared route-key ordering for the risk model tab strip (I360A-2734).
// Route keys double as the URL segments used with addRouteNamespace
// (e.g. 'results' -> results/:configId), so no separate mapping is needed.
export const RISK_TAB_ORDER = [
	'lofSetup',
	'cofSetup',
	'riskSetup',
	'results',
	'riskLog',
] as const;

export const RISK_TAB_ORDER_LEGACY = [
	'results',
	'lofSetup',
	'cofSetup',
	'riskSetup',
	'riskLog',
] as const;

export type RiskTabRouteKey = (typeof RISK_TAB_ORDER)[number];

export const getRiskTabOrder = (
	isRiskTemplatesEnabled: boolean,
): readonly RiskTabRouteKey[] =>
	isRiskTemplatesEnabled ? RISK_TAB_ORDER : RISK_TAB_ORDER_LEGACY;

export const getRiskTabIndex = (
	routeKey: RiskTabRouteKey,
	isRiskTemplatesEnabled: boolean,
): number => getRiskTabOrder(isRiskTemplatesEnabled).indexOf(routeKey);

export const getRiskTabRoute = (
	index: number,
	isRiskTemplatesEnabled: boolean,
): RiskTabRouteKey | undefined =>
	getRiskTabOrder(isRiskTemplatesEnabled)[index];

// Single source of truth for the "where does a model land" rule (I360A-2734),
// so the decision doesn't get re-derived (and risk drifting) across the
// sagas, RiskListCard, and RiskManagement.page call sites. Viewers always
// land on Results — LoF Setup is an edit-only surface they can't use.
export const getRiskLandingRoute = (
	hasBeenRun: boolean,
	isViewer = false,
): 'results' | 'lofSetup' => (isViewer || hasBeenRun ? 'results' : 'lofSetup');
